import React, {useState , useEffect} from 'react'
import logo from "../../assets/images/home/footer-logo.svg"
import '../../assets/css/footer.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import {NavLink, Link} from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import FormService from '../API-Services/FormService';
import { faClose } from '@fortawesome/free-solid-svg-icons';
function Footer() {

    const [toggleState, setToggleState] = useState();
    const [checkErrors,setCheckErrors]=useState(false);
    const [data, setData] = useState(0);
    const [loading,setLoading]=useState(false);
    const [showToaster, setShowToaster] = useState(false);
    const toggleTab = (index) => {
      setToggleState(index);
    };
    const {register,
        reset,
        handleSubmit,
        formState: { errors }}=useForm({mode:"onChange"});
     const formHandler=(data)=>{
            let payload={
            ...data
            }
            
            setLoading(true);
            FormService.NewsletterForm(payload).then((res)=>{
            setLoading(false);
            reset();
            setShowToaster(true)
            // toast.success(res.data.message);
            }).catch((err)=>{
              setLoading(false);
              if (err && err.response && err.response.data && err.response.data.message) {
              toast.error(err.response.data.message);
              }
              else{
                toast.error("Something went wrong, please try again later!");
              }
            })
            }
            useEffect(() => {
                if (showToaster) {
                  const timer = setTimeout(() => {
                    setShowToaster(false);
                  }, 10000); // Hide toaster after 10 seconds
            
                  return () => clearTimeout(timer); 
                }
              }, [showToaster]);
  return (
    <>
        <footer className='main-footer'>
            <div className='container'>
                <div className={`toaster toaster-bottom ${showToaster ? 'toaster-active' : ''}`}>
                      <div className='close-tst' onClick={() => setShowToaster(false)}>
                        <FontAwesomeIcon icon={faClose} />
                      </div>
                      <h3 className='tst-heading'>Thank you for subscribing!</h3>
                      <p className='fnt-11'>Please check your spam folder and mark our emails as trusted to ensure you receive our monthly newsletter.</p>
                </div>
                <div className='flx-head'>
                    <div className='logo'>
                        <a href='/'>
                            <img src={logo} alt='Choice Techlab' width={142} height={58}/>
                        </a>

                        
                        
                    </div>

                    <div className='newsletter-form'>
                        <div className='sub-text'>
                            <p>Subscribe to our newsletter</p>
                            <span className='info-icon'>
                                <FontAwesomeIcon icon={faInfoCircle} />
                                <em className='tooltip-cust'>Stay updated with our latest tech innovations and insights, market trends and more - subscribe to our monthly newsletter!</em>
                            </span>
                        </div>
                        <form className='flx-form' onSubmit={handleSubmit(formHandler)}>
                            <div className='form-grp'>
                                <input type='text' placeholder='Email Address' className='form-field'
                                autoComplete='off'
                                  {...register("email",{
                                  required:true,
                                  pattern:/^[a-zA-Z]{1}[A-Za-z0-9._%+-]{1,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})$/
                                  })} />
                                  {errors.email?.type==="pattern" ? <span className="text-danger">Please enter valid email ID </span>:
                                 errors.email?.type==="required" ? <span className="text-danger">Email is required</span>:""}
                            </div>
                            <button type='submit' className='subs-btn' onClick={()=>{
                                  setCheckErrors(true);
                                  }}>Subscribe</button>
                        </form>
                    </div>
                </div>
                <div className='footer-menu'>
                    
                    <div className='menu-list'>
                        <h4>Company</h4>
                        <ul className='lst-itm'>
                            <li>
                                <NavLink to= '/about-us' >About Us</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/contact-us' >Contact Us</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/career' >Career</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='menu-list'>
                        <h4>Products</h4>
                        <ul className='lst-itm'>
                            <li>
                                <NavLink to= '/products/procurement-management-software' >Prime: Procurement</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/products/invoice-generation-software' >Prime: Cash Flow Management</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/products/exployee-expenses-management-system' >Prime: Employee Benefits</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/products/employee-management-system' >Choice Touch</NavLink>
                            </li>
                            {/* <li>
                                <NavLink to= '/products/telelyzer' >Telelyzer</NavLink>
                            </li> */}
                            <li>
                                <NavLink to= '/products/customer-engagement-platform' >Greetly</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/products/insurance-management-system' >Drive Assure</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/products/transport-management-system' >Trans-Track</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='menu-list'>
                        <h4>Services</h4>
                        <ul className='lst-itm'>
                            <li>
                                <NavLink to= '/services/android-app-development' >Android Development</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/services/ios-app-development' >iOS Development</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/services/web-development-services' >Web Development</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/services/tech-consulting-services'>Tech Consultation</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/services/data-loss-protection' >Data Loss Prevention (DLP)</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/services/data-classification-platform' >Data Classification Platform</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/services/red-teaming-services' >Red Teaming</NavLink>
                            </li>
                        </ul>
                    </div>
                   
                    <div className='menu-list'>
                        <h4>Resources</h4>
                        <ul className='lst-itm'>
                            <li>
                                <NavLink to= '/enhance-logistics-efficiency-and-customer-satisfaction-with-choice-touch'>Enhancing Logistics Efficiency</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/enhancing-customer-experience-with-greetly' >Improving Customer Engagement</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/streamlining-expense-managment-in-manufacturing-with-prime' >Streamline Expenses</NavLink>
                            </li>
                            <li>
                                <NavLink to= '/enhancing-supply-chain-efficiency-with-prime' >Optimized SCF</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className='btm-footer'>
                    <div className='social-media-sec'>
                    <div className='social-links'>
                        <span>Follow us:</span>
                        <ul className='links-itm'>
                            <li>
                                <a href='https://www.facebook.com/choicetechlab' target='_blank' aria-label="Facebook" rel="noopener">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.5 6.975V9.15H12.45C12.6 9.15 12.675 9.3 12.675 9.45L12.375 10.875C12.375 10.95 12.225 11.025 12.15 11.025H10.5V16.5H8.25V11.1H6.975C6.825 11.1 6.75 11.025 6.75 10.875V9.45C6.75 9.3 6.825 9.225 6.975 9.225H8.25V6.75C8.25 5.475 9.225 4.5 10.5 4.5H12.525C12.675 4.5 12.75 4.575 12.75 4.725V6.525C12.75 6.675 12.675 6.75 12.525 6.75H10.725C10.575 6.75 10.5 6.825 10.5 6.975Z" stroke="white" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round"/>
                                    <path d="M11.25 16.5H6.75C3 16.5 1.5 15 1.5 11.25V6.75C1.5 3 3 1.5 6.75 1.5H11.25C15 1.5 16.5 3 16.5 6.75V11.25C16.5 15 15 16.5 11.25 16.5Z" stroke="white" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                </a>
                            </li>
                            <li>
                                <a href='https://www.instagram.com/choicetechlab_official/' target='_blank' aria-label="Instagram" rel="noopener">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M5 0.5H10.775C13.2603 0.5 15.275 2.51472 15.275 5V10.775C15.275 13.2603 13.2603 15.275 10.775 15.275H5C2.51472 15.275 0.5 13.2603 0.5 10.775V5C0.5 2.51472 2.51472 0.5 5 0.5ZM14.15 5C14.1459 3.13775 12.6372 1.62912 10.775 1.625H5C3.13775 1.62912 1.62912 3.13775 1.625 5V10.775C1.62912 12.6372 3.13775 14.1459 5 14.15H10.775C12.6372 14.1459 14.1459 12.6372 14.15 10.775V5Z" fill="white"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M4.6625 7.8875C4.66662 6.10809 6.10809 4.66662 7.8875 4.6625C9.66691 4.66662 11.1084 6.10809 11.1125 7.8875C11.1125 9.66862 9.66862 11.1125 7.8875 11.1125C6.10638 11.1125 4.6625 9.66862 4.6625 7.8875ZM9.9875 7.8875C9.9875 6.7277 9.0473 5.7875 7.8875 5.7875C6.72941 5.79161 5.79161 6.72941 5.7875 7.8875C5.7875 9.0473 6.7277 9.9875 7.8875 9.9875C9.0473 9.9875 9.9875 9.0473 9.9875 7.8875Z" fill="white"/>
                                    <path d="M10.6325 3.87875C10.6325 3.42933 10.9968 3.065 11.4462 3.065C11.8957 3.065 12.26 3.42933 12.26 3.87875C12.26 4.32817 11.8957 4.6925 11.4462 4.6925C10.9968 4.6925 10.6325 4.32817 10.6325 3.87875Z" fill="white"/>
                                </svg>
                                </a>    
                            </li>
                            <li>
                                <a href='https://www.linkedin.com/company/choice-techlab-solutions-pvt-ltd/mycompany/' target='_blank' aria-label="Linkedin" rel="noopener">
                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M2.66876 4.00003C1.88895 4.00657 1.10898 4.00514 0.329116 4.0008C0.108768 3.9995 -0.000400884 4.07556 1.1061e-06 4.32635C0.00488242 7.12285 0.00298732 9.91934 0.00356159 12.7158C0.00361902 12.8223 -0.0126903 12.9392 0.118416 12.9877C0.123412 13.0048 2.87263 13.0037 2.88003 12.9868C3.02475 12.9304 2.99558 12.7992 2.99563 12.6858C2.9969 9.90906 2.99466 7.13224 3 4.35547C3.0004 4.1035 2.91414 3.99795 2.66876 4.00003Z" fill="white"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M1.49997 0.25C0.671599 0.25 0 0.921599 0 1.74997C0 2.57845 0.671599 3.25 1.49997 3.25C2.3284 3.25 3 2.57845 3 1.74997C3 0.921599 2.3284 0.25 1.49997 0.25Z" fill="white"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M12.7111 12.5689C12.7129 11.1355 12.7202 9.70207 12.7085 8.26879C12.7034 7.64095 12.6809 7.01148 12.5489 6.39357C12.3326 5.38049 11.8459 4.58954 10.879 4.22072C10.234 3.97468 9.55959 3.95884 8.88599 4.05422C8.32014 4.13434 7.79889 4.34987 7.32401 4.75049C7.32401 4.60473 7.32351 4.50807 7.32412 4.41153C7.32557 4.19471 7.22467 4.0967 7.01681 4.0977C6.2781 4.10114 5.53939 4.10027 4.80062 4.09828C4.59727 4.0977 4.49972 4.18168 4.5 4.41024C4.5039 7.16079 4.50245 9.91135 4.50256 12.6619C4.50256 12.7674 4.48868 12.8796 4.61076 12.9315C4.62364 12.9486 7.29062 12.9549 7.29051 12.9376C7.46543 12.859 7.41164 12.6932 7.41192 12.5582C7.41437 11.2016 7.40623 9.8449 7.41353 8.48829C7.41576 8.06407 7.43143 7.63551 7.61465 7.24051C7.83177 6.77245 8.28112 6.56966 8.91403 6.65264C9.34944 6.70968 9.62738 7.00452 9.71389 7.51816C9.74594 7.70792 9.76991 7.90195 9.77103 8.09416C9.7795 9.58641 9.78067 11.0787 9.78686 12.5709C9.78747 12.7087 9.74611 12.8714 9.92359 12.9407C9.91752 12.9602 12.6029 12.9484 12.6036 12.9294C12.7481 12.8452 12.7109 12.6982 12.7111 12.5689Z" fill="white"/>
                                </svg>
                                </a>
                            </li>
                            <li>
                                <a href='https://twitter.com/choicetechlab' target='_blank' aria-label="Twitter" rel="noopener">
                                    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M6.93117 8.18079L0.75 0.5H5.64593L9.46151 5.24726L13.5379 0.521375H16.2343L10.7652 6.86933L17.25 14.9375H12.3687L8.23719 9.80364L3.8264 14.9233H1.11537L6.93117 8.18079ZM13.0802 13.5144L3.75202 1.92311H4.93389L14.2503 13.5144H13.0802Z" fill="white"/>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className='copyrights'>
                        <p>&copy; Copyright 2024 Choice Techlab All rights reserved.</p>
                    </div>
                    </div>
                
                </div>
            </div>
        </footer>
    </>
  )
}

export default Footer